<template>
  <div class="notFound">
    <img :src="defaultUrl" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultUrl: require("@/assets/images/404.png")
    }
  },
  created() {
    this.$store.commit("update_show_nav", true)
  }
}
</script>

<style lang="scss" scoped>
.notFound {
  display: flex;
  justify-content: center;
  margin-top: 100px;
}
</style>
